import React from 'react';
import { ActionButton, Flex } from '@adobe/react-spectrum';
import ChevronLeft from '@spectrum-icons/workflow/ChevronLeft';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
const ChangeButton = (props) => {
    const { direction } = props;
    const dispatch = useAppDispatch();
    const onPress = () => {
        switch (direction) {
            case 'prev':
                dispatch(ProjectActions.gotoPrevPage());
                break;
            case 'next':
                dispatch(ProjectActions.gotoNextPage());
                break;
            default:
                break;
        }
    };
    return (React.createElement(Flex, { flex: "0", alignItems: "stretch", justifyContent: "stretch" },
        React.createElement(ActionButton, { width: "100%", height: "100%", isQuiet: true, onPress: onPress, UNSAFE_style: { borderRadius: '0' } }, props.children)));
};
export const Pagination = (props) => {
    const { children } = props;
    return (React.createElement(Flex, { direction: "row", height: "100%", width: "100%", minHeight: "0px", flex: "1 1 auto" },
        React.createElement(ChangeButton, { direction: "prev" },
            React.createElement(ChevronLeft, null)),
        children,
        React.createElement(ChangeButton, { direction: "next" },
            React.createElement(ChevronRight, null))));
};
